import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { HorizontalListData } from "../../../../ui/horizontal-list/horizontal-list.model";
import { ShowDisclosuresData } from "../../../models/show-disclosures-data.model";
import { OfferCalculator } from "../../../services/offer-calculator";
import { OfferCalculatorService } from "../../../services/offer-calculator.service";
import { OfferCalculatorDetailsTableAdapter } from "./offer-calculator-details-table.data";
import { HorizontalListActions } from "./offer-calculator-details-table.model";

@UntilDestroy()
@Component({
    selector: "ifc-offer-calculator-details-table",
    templateUrl: "./offer-calculator-details-table.component.html",
    styleUrls: ["./offer-calculator-details-table.component.scss"],
    providers: [OfferCalculatorDetailsTableAdapter],
    standalone: false
})
export class OfferCalculatorDetailsTableComponent implements OnInit, OnChanges {
  @Input() offerCalculator: OfferCalculator;
  @Input() showCommission: boolean;
  @Input() showTerm: boolean;

  detailsListItems: HorizontalListData[];
  costListItems: HorizontalListData[];

  @Output() showDisclosures = new EventEmitter<ShowDisclosuresData>();

  constructor(
    private readonly adapter: OfferCalculatorDetailsTableAdapter,
    private readonly calculatorService: OfferCalculatorService,
  ) { }

  ngOnInit(): void {
    this.calculatorService.inputDataChanged$.pipe(untilDestroyed(this))
      .subscribe(() => {
        this.initListData();
      })
  }

  // The parent swaps the calculator when the applicant switches offers on the same route.
  ngOnChanges(): void {
    this.initListData();
  }

  private initListData(): void {
    this.detailsListItems = this.adapter.adaptDetailsListData(this.offerCalculator, this.showTerm, this.showCommission);
    this.costListItems = this.adapter.adaptCostListData(this.offerCalculator);
  }

  onActionClicked(actionName: string): void {
    if (actionName === HorizontalListActions.ShowDisclosures) {
      const data: ShowDisclosuresData = {
        applicationId: this.offerCalculator.application.id,
        applicationUuid: this.offerCalculator.application.uuid,
        offerId: this.offerCalculator.applicationOffer.id,
      };
      this.showDisclosures.emit(data);
    }
  }
}
